import type { FaireProductEntity } from "../../entity_types/product";

export const p_egy36m867b: FaireProductEntity = {
  token: "p_egy36m867b",
  type: "product",
  name: "W.A.Y Silky Poly Long Horse Dress",
  brandToken: "b_8uyj93ctm1",
  brandName: "W.A.Y. --Wonderful And Young",
  imageUrl:
    "https://cdn.faire.com/fastly/10440e729c37d6996b04277211dd6b1b6ba01a89dba695a58380f5757508b572.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac1cc581ecf05651e6ba0c684439c9a615f5bd9888e34cd1ae1df5d32d474687.jpeg",
    "https://cdn.faire.com/fastly/7e5d4e8dcfa27d576474261c09a0365f00167cf5156815f288b208e9f44a4953.jpeg",
    "https://cdn.faire.com/fastly/981462ccfbb1611147fe2ed4862dc8b6039500d885c221e1e881a0c6d5e5b42a.jpeg",
  ],
  priceDollars: 68,
  description:
    "Embrace effortless Western elegance with the W.A.Y Silky Poly Long Horse Dress. Crafted from a lightweight silky-feel poly fabric with a soft satin-inspired finish, this maxi dress drapes beautifully and moves gracefully with every step. Featuring an eye-catching horse print that captures the spirit of the open range, this dress blends bohemian charm with modern Western style.\n\nDesigned with delicate shoulder straps and a flowing silhouette, it offers a flattering, feminine fit that is both comfortable and versatile. The airy fabric creates a fluid movement, making it perfect for warm-weather days, vacations, festivals, or special occasions.\n\nFeatures:\n-Exclusive horse print inspired by Western heritage\n-Adjustable shoulder straps\n-Flowy maxi-length silhouette\n-Lightweight and breathable for all-day comfort\n\nStyle it with Western boots and a cowboy hat for a statement look, or pair it with sandals and layered jewelry for an elevated boho-chic outfit.\n\nContent: 97% POLYESTER 3% SPANDEX\nColor/print: #P68 BLACK+ Brown Horse / #P70 champagne + Black Horse\n",
  tags: [],
  msrpDollars: 136,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:34.824Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
